<template>
  <div>
    <h1>Bank Transfer Deposit</h1>

    <BackButton
      text="Back to Deposit Menu"
      @click="backmenu"
    />

    <p>
      You can deposit money on your wallet via bank transfer.<br>
      <img src="/icons/paychangu.png" alt="Paychangu Logo" style="height: 20px; vertical-align: middle; margin-right: 5px;">
      Paychangu Bank Transfer.<br>
      Hello user: <a>{{ username }}</a>
    </p>

    <!-- Loading initial bank account -->
    <div v-if="isLoadingAccount" style="text-align:center; padding: 30px;">
      <span class="spinner" style="border-color: rgba(0,0,0,0.2); border-top-color:#1a73e8; width:24px; height:24px;"></span>
      <p style="color:#555; margin-top:10px;">Loading account info...</p>
    </div>

    <!-- Step 1: Enter details & generate account -->
    <div v-if="!isLoadingAccount && !bankDetails" class="contenedor">
      <p class="step-label">Enter your details and generate your unique bank account to make the transfer.</p>

      <div class="field-grid">
        <div class="field-group">
          <label class="field-label">First Name</label>
          <input
            v-model.trim="form.firstName"
            type="text"
            placeholder="First name"
            class="field-input"
          >
        </div>
        <div class="field-group">
          <label class="field-label">Last Name</label>
          <input
            v-model.trim="form.lastName"
            type="text"
            placeholder="Last name"
            class="field-input"
          >
        </div>
      </div>

      <button
        class="btn-generate"
        type="button"
        :disabled="!form.firstName || !form.lastName"
        @click="generateBankAccount"
      >
        <span v-if="isGenerating">
          <span class="spinner"></span> Generating...
        </span>
        <span v-else>🏦 Generate Bank Account</span>
      </button>
    </div>

    <!-- Step 2: Bank account details card -->
    <div v-if="!isLoadingAccount && bankDetails" class="account-card">
      <div class="account-card-header">
        <img src="/icons/paychangu.png" alt="Paychangu" class="card-logo" />
        <span>Transfer to this bank account</span>
      </div>

      <div class="account-card-body">
        <div class="detail-row">
          <span class="detail-label">Bank Name</span>
          <span class="detail-value">{{ bankDetails.bankName }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Account Name</span>
          <span class="detail-value">{{ bankDetails.accountName }}</span>
        </div>

        <div class="detail-row copyable">
          <span class="detail-label">Account Number</span>
          <div class="detail-copy-row">
            <span class="detail-value highlight">{{ bankDetails.accountNumber }}</span>
            <button class="btn-copy" @click="copyText(bankDetails.accountNumber, 'account')">
              {{ copied === 'account' ? '✔ Copied' : 'Copy' }}
            </button>
          </div>
        </div>

      </div>

      <div class="account-card-footer">
        <p class="warning">⚠ Use <strong>exactly</strong> the Account Number above when making the transfer so your deposit is matched automatically.</p>
      </div>
    </div>

    <!-- Actions after generating account -->
    <!-- <div v-if="!isLoadingAccount && bankDetails" class="actions">
      <button class="btn-new" @click="resetForm">&#8635; Generate a New Account</button>
    </div> -->

    <ResponseMessage
      :message="responseMessage"
      :type="responseType"
    />

    <div class="finaltext">
      <p v-if="bankDetails">
        Your deposit will appear on your wsbetting.co.mw account once the transfer is confirmed.<br>
        If your deposit doesn't appear within 5 minutes,
        <a href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us.
      </p>
      <p v-else>
        After generating your bank account and completing the transfer,
        your deposit will appear on your wsbetting.co.mw account.<br>
        <a>Note</a>: Each generated account is unique to your transaction — do not share it.
      </p>
    </div>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton.vue';
import ResponseMessage from '@/components/ResponseMessage.vue';
import paychanguService from '@/scripts/ApiServicePaychangu.js';

export default {
  components: {
    BackButton,
    ResponseMessage
  },
  data() {
    return {
      username: this.$route.query.username || 'Unknown User',
      isLoadingAccount: true,
      form: {
        firstName: '',
        lastName: ''
      },
      isGenerating: false,
      bankDetails: null,
      copied: null,
      responseMessage: '',
      responseType: ''
    };
  },
  methods: {
    async loadBankAccount() {
      this.isLoadingAccount = true;
      const response = await paychanguService.getBankAccountDetails({
        username: this.username,
        division: 'Malawi'
      });
      if (response && response.success && response.data.exist) {
        this.bankDetails = {
          bankName: response.data.bank_name,
          accountName: response.data.account_name,
          accountNumber: response.data.account_number
        };
      }
      this.isLoadingAccount = false;
      this.$nextTick(() => this.sendHeight());
    },
    backmenu() {
      this.$router.push({
        name: 'DepositWebsiteMalawi',
        query: { username: this.$route.query.username }
      });
    },
    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },
    async generateBankAccount() {
      if (!this.form.firstName || !this.form.lastName) return;

      this.isGenerating = true;
      this.responseMessage = '';
      this.bankDetails = null;

      const response = await paychanguService.generateacountbank({
        username: this.username,
        first_name: this.form.firstName,
        last_name: this.form.lastName
      });

      if (response && response.success) {
        const details = response.data.payment_account_details;
        this.bankDetails = {
          bankName: details.bank_name,
          accountName: details.account_name,
          accountNumber: details.account_number
        };
      } else {
        this.responseMessage = response?.message || 'Failed to generate bank account. Please try again.';
        this.responseType = 'error';
      }

      this.isGenerating = false;
      this.$nextTick(() => this.sendHeight());
    },
    copyText(text, field) {
      navigator.clipboard.writeText(text).then(() => {
        this.copied = field;
        setTimeout(() => { this.copied = null; }, 2000);
      });
    },
    resetForm() {
      this.bankDetails = null;
      this.form.firstName = '';
      this.form.lastName = '';
      this.copied = null;
      this.responseMessage = '';
      this.$nextTick(() => this.sendHeight());
    },
    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, '*');
    }
  },
  mounted() {
    this.loadBankAccount();
    window.addEventListener('resize', this.sendHeight);
  },
  updated() {
    this.$nextTick(() => this.sendHeight());
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.sendHeight);
  }
};
</script>

<style scoped>
h1 {
  color: #000;
  text-align: center;
  font-weight: 800;
  padding: 15px;
}

p {
  color: #555;
  text-align: center;
}

/* ── Step 1: generate form ── */
.contenedor {
  padding: 30px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #e7e7e7;
}

.step-label {
  font-size: 14px;
  color: #444;
  margin-bottom: 18px;
}

.field-grid {
  width: 30%;
  min-width: 275px;
  display: grid;
  gap: 12px;
  margin-bottom: 16px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.field-input {
  padding: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  box-sizing: border-box;
  border-radius: 0;
  width: 100%;
}

.btn-generate {
  width: 30%;
  min-width: 275px;
  margin-top: 10px;
  padding: 12px 20px;
  cursor: pointer;
  color: #fff;
  background-color: #1a73e8;
  border: 2px solid #1a73e8;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 700;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.btn-generate:hover:not(:disabled) {
  background-color: #1558b0;
  border-color: #1558b0;
}

.btn-generate:disabled {
  cursor: not-allowed;
  background-color: #ccc;
  border-color: #ccc;
}

/* spinner */
.spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
  margin-right: 4px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Step 2: bank account card ── */
.account-card {
  margin: 20px auto;
  width: 90%;
  max-width: 460px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  overflow: hidden;
  background: #fff;
}

.account-card-header {
  background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
  color: #fff;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 15px;
}

.card-logo {
  height: 24px;
  filter: brightness(0) invert(1);
}

.account-card-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 13px;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  flex-shrink: 0;
}

.detail-value {
  font-size: 15px;
  color: #1a2332;
  font-weight: 600;
  text-align: right;
}

.detail-copy-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.highlight {
  background: #f0f4ff;
  padding: 4px 10px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 15px;
  color: #1a2332;
  letter-spacing: 0.5px;
}

.btn-copy {
  padding: 4px 10px;
  font-size: 12px;
  border: 1px solid #1a73e8;
  border-radius: 4px;
  color: #1a73e8;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-copy:hover {
  background: #1a73e8;
  color: #fff;
}

.account-card-footer {
  background: #fff8e1;
  padding: 12px 20px;
}

.warning {
  color: #7a5c00;
  font-size: 13px;
  text-align: left;
  margin: 0;
}

/* ── Instructions ── */
.instructions {
  margin: 20px auto;
  width: 90%;
  max-width: 460px;
  background: #f9f9f9;
  border-left: 4px solid #1a73e8;
  border-radius: 6px;
  padding: 16px 20px;
}

.instructions h3 {
  margin: 0 0 12px;
  font-size: 15px;
  color: #1a2332;
  font-weight: 700;
}

.instructions ol {
  margin: 0;
  padding-left: 18px;
  color: #444;
  font-size: 14px;
  line-height: 1.8;
}

/* ── Actions ── */
.actions {
  display: flex;
  justify-content: center;
  margin: 16px 0;
}

.btn-new {
  padding: 9px 22px;
  font-size: 13px;
  border: 2px solid #999;
  border-radius: 6px;
  color: #555;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-new:hover {
  background: #f0f0f0;
}

/* ── Final text ── */
.finaltext {
  padding-left: 10px;
  padding-right: 10px;
  display: block;
}
</style>
